import { CompetitionBlacklist } from './competition-blacklist'
import { Injectable } from '@angular/core'

@Injectable()
export class CompetitionBlacklistSerializer {
  fromJson(json: any): CompetitionBlacklist {
    const competitionBlacklist = {
      ...json
    }

    return competitionBlacklist
  }

  toJson(competitionBlacklist: CompetitionBlacklist): any {
    return {
      ...competitionBlacklist
    }
  }
}
